import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-mexico',
  templateUrl: './product-mexico.component.html',
  styleUrls: ['./product-mexico.component.css']
})
export class ProductMexicoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
